import { render, staticRenderFns } from "./AreaFilterSelector.vue?vue&type=template&id=53033782&scoped=true"
import script from "./AreaFilterSelector.vue?vue&type=script&lang=js"
export * from "./AreaFilterSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53033782",
  null
  
)

export default component.exports